import type { SWSettings } from "app/common/services/swSettings";
import { swSettings } from "app/common/services/swSettings";
import { i18nFilter, translate } from "app/filters/i18nFilter";
import _ from "lodash";
import ConversionSegment from "pro-features/pages/conversion/ConversionSegment/ConversionSegment";
import type { ComponentType } from "react";
import { PureComponent } from "react";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { connect } from "react-redux";
import type { ISegmentsData } from "app/services/conversion/ConversionSegmentsService";
import DurationService from "app/services/DurationService";
import { allTrackers } from "app/services/track/track";
import ConversionApiService from "../../services/conversion/conversionApiService";

class SegmentOverviewContainerComponent extends PureComponent<any, any> {
    public pageFilters: any;
    public swNavigator: any;
    public swSettings: SWSettings;
    public isCompare: boolean;
    public data: any;
    private readonly conversionApiService: any;
    private segmentsData: ISegmentsData;
    private graphData: any;
    private durationDataForWidget: string[];

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        };
        this.swSettings = swSettings;
        this.conversionApiService = new ConversionApiService();
        this.swNavigator = proNavigator;
        this.pageFilters = this.swNavigator.getApiParams();
    }

    public async componentDidMount() {
        this.pageFilters = this.swNavigator.getApiParams();
        const { country, webSource = "Desktop", from, to, sid } = this.pageFilters;
        const { duration, comparedDuration } = this.swNavigator.getParams();
        const durationData = DurationService.getDurationData(
            duration,
            comparedDuration,
            this.swSettings.getCurrentComponent().componentId,
        );
        const { compareFrom, compareTo } = durationData.forAPI;
        let graphResponse;
        try {
            graphResponse = await this.conversionApiService.getWebsiteConversionGraph({
                country,
                webSource,
                from,
                to,
                compareFrom,
                compareTo,
                sid,
            });
        } catch (e) {}
        this.graphData = graphResponse?.Data ? graphResponse : {};
        this.durationDataForWidget = _.isArray(durationData.forWidget) ? durationData.forWidget.reverse() : undefined;
        this.setState({ loading: false });
    }

    public homeRedirect = () => {
        this.swNavigator.go("/");
    };

    public render() {
        const { gid, sid, country } = this.pageFilters;
        const isSingleLob = _.get(this.props.segments, `["segments"]["${sid}"]["isSingleLob"]`, true);
        const pageProps = {
            loading: this.state.loading,
            translate: i18nFilter(),
            track: allTrackers.trackEvent.bind(allTrackers),
            pageFilters: this.pageFilters,
            graphData: this.graphData,
            durationDataForWidget: this.durationDataForWidget,
            onGraphDDClick: (obj) => console.log("downloading graph " + obj.id),
            getLink: this.swNavigator.href.bind(this.swNavigator),
            segmentsData: this.props.segments,
            isSingleLob,
        };

        const permissions = {
            HOOK: this.homeRedirect, // Should be a modal
            HIDDEN: this.homeRedirect,
            OPEN: () => <ConversionSegment {...pageProps} />,
        };

        return hasPermissions(
            permissions,
            this.swSettings.current.resources.AvaliabilityMode?.toUpperCase() || "OPEN",
        )();
    }
}

const hasPermissions = (permissions, permission) => {
    return permissions[permission];
};

function mapStateToProps({ conversionModule: { segments } }) {
    return {
        segments,
    };
}

export const SegmentOverviewContainer = connect(
    mapStateToProps,
    null,
)(SegmentOverviewContainerComponent as ComponentType<any>);
